import styled from 'styled-components'
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js'
import { InputStyleProps, inputStyles } from 'components/generic/Input/styles'

export const CardNumberInput = styled(CardNumberElement)<InputStyleProps>`
  ${inputStyles}
  padding-top: 16px;
`
export const CardExpiryInput = styled(CardExpiryElement)<InputStyleProps>`
  ${inputStyles}
  padding-top: 16px;
`

export const CardCvcInput = styled(CardCvcElement)<InputStyleProps>`
  ${inputStyles}
  padding-top: 16px;
`

export const FormRow = styled.div`
  display: flex;
  justify-content: space-between;

  & > div {
    flex-basis: 45%;
  }
`

export const PaymentTerms = styled.p`
  color: rgb(100, 100, 108);
  font-size: 14px;
  line-height: 1.4;

  a {
    color: ${({ theme }) => theme.colors.inverseColor};
    text-decoration: underline;
  }
`

export const PaymentForm = styled.form`
  text-align: left;
`
